import * as actionTypes from './actionTypes';
import { Dispatch } from 'redux';

interface CustomFieldAnswer {
	key?: string;
	label?: string;
	value: string;
	fieldName?: string;
	fieldValue?: string;
}

interface SetInitialCustomFieldAnswersAction {
	type: typeof actionTypes.SET_INITIAL_CUSTOM_FIELD_ANSWERS;
	careOrderCustomFields: CustomFieldAnswer[];
	decisionSupportCustomFields: CustomFieldAnswer[];
}

export function setInitialCustomFieldAnswers(
	careOrderCustomFields: CustomFieldAnswer[],
	decisionSupportCustomFields: CustomFieldAnswer[]
) {
	return function (dispatch: Dispatch<SetInitialCustomFieldAnswersAction>): Promise<void> {
		dispatch(setInitialCustomFieldAnswersAction(careOrderCustomFields, decisionSupportCustomFields));
		return Promise.resolve();
	};
}

function setInitialCustomFieldAnswersAction(
	careOrderCustomFields: CustomFieldAnswer[],
	decisionSupportCustomFields: CustomFieldAnswer[]
): SetInitialCustomFieldAnswersAction {
	return {
		type: actionTypes.SET_INITIAL_CUSTOM_FIELD_ANSWERS,
		careOrderCustomFields: careOrderCustomFields,
		decisionSupportCustomFields: decisionSupportCustomFields,
	};
}